    <mat-card appearance="outlined" *ngIf="processing">
    <span>Loading</span><br />
    <mat-progress-bar mode="query"></mat-progress-bar>
    </mat-card>
<!--   
  <mat-card appearance="outlined" *ngIf="!processing">
    <mat-card-title class="text-red-400">Multi-Factor Authentication (MFA) is required for this application</mat-card-title>
        <section><span>&nbsp;</span></section>
        <section *ngIf="authService.expired() && step==1">
            <span >Your session has either expired or needs to be initialized.  Please click the button below to recieve an access code:</span> <br /><br />
            <form>
        
                <mat-form-field class="m-r-8">
                  <mat-label>Delivery method</mat-label>
                   <mat-select name="Delivery method"  [(ngModel)]="deliveryMethod" (selectionChange)="onDeliveryMethodChange()" required> 
                    <mat-option>-- None --</mat-option>
                    <mat-option *ngFor="let dm of supportedDeliveryMethods" value="{{dm}}">{{dm}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <span class="m-r-8" *ngIf="deliveryMethod != null && deliveryMethod.length > 0">
                    <span *ngIf="deliveryReceipient != null && deliveryReceipient.length > 0">
                        to {{deliveryReceipient}}
                    </span>
                    <span *ngIf="deliveryReceipient == null || deliveryReceipient.length == 0" class="text-red-400">
                        Invalid {{deliveryMethod}}
                    </span>
                </span>        
                <button mat-raised-button color="primary" [disabled]="getCodeDisabled || processing" (click)="getCode()">Get Code</button> 
              </form>
        </section>
  
         
        <section *ngIf="authService.expired() && step==2">
          <form>          
            <span>An access code has been sent via {{deliveryMethod}} to <strong>{{deliveryReceipient}}</strong></span><br />
            <mat-form-field [style.width.px]=327>
              <mat-label>Code</mat-label>
              <input matInput placeholder="Enter Access Code" [(ngModel)]="code" name="code">
            </mat-form-field>
            <span>&nbsp;</span>
            <button mat-raised-button color="primary" [disabled]="validateCodeDisabled || processing || code == null || code.length == 0" (click)="validateCode()">Validate Code</button> 
          </form>
          <span> or <a (click)="resend()">send a new access code.</a></span>
        </section>


        <div *ngIf="!authService.expired()">
            <div class="w-full">   
                <span >Your session has been updated.  Thank you!</span>  
              </div>
        </div>
        
  
 
  

        
     
  </mat-card>
   -->
